import React, { useMemo, useState } from 'react';
import bg from './assests/bg-1.jpg';
import { Select, Button } from 'components/ui';
import { IoSearch } from 'react-icons/io5';
import { useHomePage } from './talons/useHomePage';
import { useNavigate } from 'react-router-dom';
import useResponsive from 'utils/hooks/useResponsive';

const SearchBanner = () => {
  const navigate = useNavigate();
  const { specialties, doctors } = useHomePage();
  const [selectedSpecialty, setSelectedSpecialty] = useState();
  const { larger } = useResponsive();

  const options = useMemo(() => {
    if (specialties && doctors) {
      return [
        {
          label: 'Áreas da dermatologia',
          options: specialties
            .map((item) => {
              return {
                value: item.id,
                label: item.specialty,
              };
            })
            .filter((item) => item.label !== 'Sem escolha'),
        },
        {
          label: 'Médicos',
          options: doctors.map((item) => {
            return {
              value: item.id,
              label: item.name,
            };
          }),
        },
      ];
    }
  }, [specialties, doctors]);

  console.log({ doctors });

  const onSearch = () => {
    if (selectedSpecialty) {
      const doctor = doctors.find((item) => item.id === selectedSpecialty.value);
      if (doctor) {
        navigate(`/appointment/${doctor.id}/Sem escolha`);
        return;
      }

      navigate(`/results/${selectedSpecialty.label}`);
    }
  };

  return (
    <div>
      <div className="w-full sm:h-[600px] h-[570px] p-4 bg-black bg-opacity-25 flex-col justify-center items-center gap-10 inline-flex">
        <img
          src={bg}
          alt="background"
          className="absolute -z-10 w-full sm:h-[600px] h-[570px] sm:top-20 top-[78px] right-0 object-cover"
        />
        <div className="max-w-screen-lg">
          <div className="flex flex-col justify-start items-center gap-2">
            <p className="text-center text-white lg:text-3xl text-sm font-bold mb-4">
              Uma equipe de dermatologistas atualizados e experientes à sua disposição em
              qualquer área da dermatologia
            </p>

            <h1 className="text-center text-3xl font-bold sm:leading-[64px] sm:text-5xl text-teal-300">
              Agende agora sua consulta
            </h1>
          </div>
          <div className="w-full mt-12 flex justify-center sm:gap-8 gap-4 flex sm:flex-row flex-col sm:px-16">
            <div className="w-full">
              <Select
                className="text-gray-700 placeholder-gray-500"
                size="lg"
                placeholder={
                  larger.md
                    ? 'Clique aqui e escolha por área de interesse ou nome do médico'
                    : 'Buscar por área de interesse ou nome do médico'
                }
                options={options}
                onChange={(e) => setSelectedSpecialty(e)}
              ></Select>
            </div>
            <Button
              size="lg"
              variant="solid"
              onClick={onSearch}
              className="flex items-center justify-center gap-2 hadow shadow-inner"
            >
              <IoSearch size={25} color={'white'} />
              <div className="text-base font-bold leading-normal">Buscar</div>
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SearchBanner;
